import React from 'react';
import { Typography } from '@mui/material';
import ClaveUnicaFormComponent from '../../../../../../../components/ClaveUnicaForm';
import type { PostClaveUnicaApproveResponse } from '../../../../../../../types/preloan/v2';
import type { FormSchemaV3, PostClaveUnicaResponse } from '../../../../../../../types/preloan/v3';
import type { ClaveUnicaEndpointProps } from '../../../../../../../components/ClaveUnicaForm';
import getPartnerButton from '../../../../../../../components/PartnerButtons';
import { WorkerType } from '../../../../../DependentStatusDialog';
import { inviteePlrCategory } from '../../../../ComplementInvite/analyticsPages';

type ClaveUnicaRequestProps<CUResponse> = {
    formSchema: FormSchemaV3,
    postClaveUnicaApprove: (props: ClaveUnicaEndpointProps)=> Promise<
    CUResponse>
    claveUnicaSuccess: (response: CUResponse)=> void,
    patchSiiIncome: (token: string)=> Promise<CUResponse>,
    patchDependentStatus: (workerType: WorkerType)=> Promise<void>,
    patchManualVerification: ()=> Promise<void>,
}

export default function ClaveUnicaRequest<CUResponse
extends PostClaveUnicaApproveResponse|PostClaveUnicaResponse
>(props:ClaveUnicaRequestProps<CUResponse>) {
  const {
    formSchema,
    postClaveUnicaApprove,
    claveUnicaSuccess,
    patchSiiIncome,
    patchDependentStatus,
    patchManualVerification,
  } = props;

  const handleFallbackUnemployed = async (): Promise<void> => {
    await patchDependentStatus('UNEMPLOYED');
  };
  return (
    <>
      <br />
      <ClaveUnicaFormComponent<CUResponse>
        button={getPartnerButton({
          partner: {
            partnerName: formSchema.partner,
            config: formSchema.config,
            products: formSchema.products,
          },
          disabled: false,
          onClick: () => {},
          buttonLabel: 'Ingresar Clave Única',
          testingLabel: 'cu-open-dialog-button',
        })}
        customLoadingLogo={formSchema.config.styles?.minimalLogo}
        customLogo={formSchema.config.styles?.headerLogo}
        token={formSchema.PLRtoken}
        partner={{
          partnerName: formSchema.partner,
          config: formSchema.config,
          products: formSchema.products,
        }}
        pageCall={{
          category: inviteePlrCategory(formSchema.complementToken, 'PLR - ONBOARDING'),
          name: 'DIALOGO CU',
        }}
        endpoint={postClaveUnicaApprove}
        idNumber={formSchema.rut}
        origin={formSchema.origin}
        callback={claveUnicaSuccess}
        fallback={patchSiiIncome}
        fallbackUnemployed={handleFallbackUnemployed}
        fallbackManualEvaluation={patchManualVerification}
        firstMessage={(
          <Typography gutterBottom>
            ¡Al ingresar tu
            {' '}
            <b>ClaveÚnica</b>
            {' '}
            podemos darte una respuesta inmediata sobre tu
            {' '}
            {formSchema.products?.every((product) => product !== 'mortgage') ? (
              <>
                aplicación para que
                {' '}
                <b>
                  puedas recibir el dinero en menos de 24 horas!
                </b>
              </>
            ) : <span>evaluación!</span>}
            {' '}
          </Typography>
                  )}
      />
    </>
  );
}
